// Types
import { SocialMediaPostData } from "@contracts/shareStop";

export function isPostEligibleForApproval(post: SocialMediaPostData): boolean {
  return post.status === "Draft" || post.status === "Unscheduled";
}
